import { blockAtomNode } from '#src/tiptap/nodes/shared.ts'

export const EncounterNode = blockAtomNode('encounter')
